import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ContentAuthoringService } from 'src/app/services/content-authoring.service';
import { UsersService } from 'src/app/services/users.service';

@Component({
  selector: 'app-assigned-reset-request',
  templateUrl: './assigned-reset-request.component.html',
  styleUrls: ['./assigned-reset-request.component.scss']
})
export class AssignedResetRequestComponent implements OnInit {


  showDetails: boolean = false;
  panelOpenState = false;
  activeTab = 0;
  user_id:any; reject_reason: string="";
  course_id:any;assessment_id:any; request_status:number=1;
  
 showDetailsEvent() { this.showDetails = !this.showDetails;  }
  closeResult = '';userLoginData:any=[];courseId:any='';userId:any='';assignDetailResume:any=[];assignDetailResumePro:any=[];
  constructor(private router: Router,private authUser: UsersService,private route: ActivatedRoute,private spinner: NgxSpinnerService,
    private modalService: NgbModal,private contentAuthoringApi: ContentAuthoringService,) { 
    
    //alert("hello1");
  }
  ngOnInit(): void {
    //alert("hello2");
    this.userLoginData = JSON.parse(localStorage.getItem('userLoginData') || '[]');
    this.route.queryParams.subscribe(queryParams => {
      this.userId = queryParams['userId'];
      this.courseId = queryParams['courseId'];
    });
    if (this.userId =='' || this.userId == null || this.courseId =='' || this.courseId == null ) {
      this.router.navigateByUrl('/admin-login');
    }
    if((this.userId !='' || this.userId != null) && (this.courseId !='' || this.courseId !=null)){
      this.assignCourseDetail(this.userId);
    }
  }
  open(content: any, data:any) { 
   // console.log(data);
    //this.user_id = this.userLoginData.user_id
    this.user_id = this.userId
    this.course_id=data.course_id
    this.assessment_id= data.assessment_id,
    this.contactAdministrator(this.user_id,this.course_id,this.assessment_id, this.request_status)
    this.modalService.open(content, { centered: true, size: 'sm' }); 

  }
  /*******get course detail with progress */
  assignCourseDetail(userId:any){
    this.spinner.show();
    this.authUser.assignCourseDetails(userId,this.courseId).subscribe(
      data=>{
       // console.log(data,'assignCourseDetail');
        this.assignDetailResume = data.data;
        this.assignDetailResumePro = data.data.user_course_progress;
        this.spinner.hide();
      },error=>{
        this.spinner.hide();
       // console.log(error);
      }
    )
  }
  /*****second convert into hr min and sec */
  secondsToHms(d:any) {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor(d % 3600 / 60);
    var s = Math.floor(d % 3600 % 60);
    // var hDisplay = h > 0 ? h + (h == 1 ? " hr, " : " hr, ") : "";
    // var mDisplay = m > 0 ? m + (m == 1 ? " min, " : " min, ") : "";
    // var sDisplay = s > 0 ? s + (s == 1 ? " sec" : " sec") : "";
    //return hDisplay + mDisplay + sDisplay; 
    return h+ ' hr ' +m+ ' min'; 
}
  /****go read submodule */
  goViewer(modId:any,subModlId:any,courseId:any){
    this.spinner.show();
    this.authUser.subModuleStartView(this.userId,courseId,modId,subModlId).subscribe(
      data=>{
        this.router.navigate(['/viewer'], { queryParams: {modId:modId,subModlId:subModlId,courseId:courseId} });
        this.spinner.hide();
      },error=>{
        this.spinner.hide();
      }
    )
  }
  /****go read submodule */
  goViewerPass(modId:any,subModlId:any,courseId:any,view:any){
    this.router.navigate(['/viewer'], { queryParams: {modId:modId,subModlId:subModlId,courseId:courseId,view:view} });
  }
  contactAdministrator(user_id:number,course_id:any,assessment_id:any, request_status:any){
    this.spinner.show();
    this.authUser.contactAdministrator(user_id,course_id,assessment_id, request_status).subscribe(
      data=>{
      // console.log(data)
        this.spinner.hide();
      },error=>{
        this.spinner.hide();
      }
    )
  }
  openAccept(content: any, data:any) { 
   // console.log(data);
    this.user_id = data.user_id
    this.course_id=data.course_id
    this.assessment_id= data.assessment_id,
    this.request_status=2
    this.acceptRejectCourses(this.user_id,this.course_id,this.assessment_id, this.request_status, this.reject_reason)
    this.modalService.open(content, { centered: true, size: 'sm' }); 

  }
  acceptRejectCourses(user_id:number,course_id:any,assessment_id:any, request_status:any, reject_reason:any){
    this.spinner.show();
    this.authUser.ViewCoursesAcceptReject(user_id,course_id,assessment_id, request_status, reject_reason).subscribe(
      data=>{
      // console.log(data)
        this.spinner.hide();
      },error=>{
        this.spinner.hide();
      }
    )
  }
  openReject(content: any, data:any) { 
   // console.log(data);
    this.user_id = data.user_id
    this.course_id=data.course_id
    this.assessment_id= data.assessment_id,
    this.request_status=3
    this.acceptRejectCourses(this.user_id,this.course_id,this.assessment_id, this.request_status, this.reject_reason)
    this.modalService.open(content, { centered: true, size: 'sm' }); 

  }
  goToReset(){
    this.router.navigate(['/reset']);
  }

}
